// extracted by mini-css-extract-plugin
export var emailBlockLink = "_im-0";